/* SEELENHAUCH Mobile Menu Debug Tool
   Runs ONLY when URL has ?shdebug=1
*/
(() => {
  const qs = new URLSearchParams(location.search);
  if (qs.get('shdebug') !== '1' || window.__SH_MENU_DEBUG__) return;
  window.__SH_MENU_DEBUG__ = true;

  const $ = (s, r=document) => r.querySelector(s);
  const $$ = (s, r=document) => [...r.querySelectorAll(s)];
  const esc = s => String(s ?? '').replace(/[&<>\"]/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','\"':'&quot;'}[c]));

  const short = el => {
    if (!(el instanceof Element)) return '(none)';
    const id = el.id ? `#${el.id}` : '';
    const cls = typeof el.className === 'string' && el.className.trim()
      ? '.' + el.className.trim().split(/\s+/).slice(0,5).join('.') : '';
    return `${el.tagName.toLowerCase()}${id}${cls}`;
  };

  const styles = el => {
    if (!(el instanceof Element)) return {};
    const s = getComputedStyle(el);
    return {
      element: short(el), position: s.position, zIndex: s.zIndex,
      pointerEvents: s.pointerEvents, transform: s.transform,
      opacity: s.opacity, visibility: s.visibility, display: s.display,
      overflow: s.overflow, isolation: s.isolation
    };
  };

  const createsStacking = el => {
    const s = getComputedStyle(el);
    return ['fixed','sticky'].includes(s.position) ||
      (['absolute','relative'].includes(s.position) && s.zIndex !== 'auto') ||
      s.opacity !== '1' || s.transform !== 'none' || s.filter !== 'none' ||
      s.perspective !== 'none' || s.isolation === 'isolate' ||
      s.willChange.includes('transform') || s.contain.includes('paint') ||
      s.contain.includes('layout');
  };

  const stackingAncestors = el => {
    const out=[]; let n=el?.parentElement;
    while (n && n !== document.documentElement) {
      if (createsStacking(n)) out.push(styles(n));
      n=n.parentElement;
    }
    return out;
  };

  const visibleMenuLinks = () => {
    const nodes = $$('header-drawer a, .menu-drawer a, #menu-drawer a, header a');
    return nodes.filter((a,i,arr) => arr.indexOf(a)===i).filter(a => {
      const r=a.getBoundingClientRect(), s=getComputedStyle(a);
      return r.width>8 && r.height>8 && r.bottom>0 && r.top<innerHeight &&
        s.display!=='none' && s.visibility!=='hidden';
    });
  };

  const hit = link => {
    const r=link.getBoundingClientRect();
    const x=Math.max(1, Math.min(innerWidth-1, r.left + Math.min(r.width*.5,80)));
    const y=Math.max(1, Math.min(innerHeight-1, r.top+r.height/2));
    const stack=document.elementsFromPoint(x,y);
    const top=stack[0] || null;
    const ok=!!top && (top===link || link.contains(top) || top.closest('a')===link);
    return {
      text: link.textContent.trim().replace(/\s+/g,' ').slice(0,80),
      link: short(link), href: link.href, receivesClick: ok,
      point:{x:Math.round(x),y:Math.round(y)},
      topElement: short(top), topStyle: styles(top),
      stack: stack.slice(0,10).map(styles),
      linkStyle: styles(link),
      linkStackingAncestors: stackingAncestors(link),
      topStackingAncestors: stackingAncestors(top)
    };
  };

  let lastReport=null;

  function analyze(){
    const hero=$('.maison-hero-v2__content') || $('.maison-hero-v2') || $('[class*="maison-hero"]');
    const links=visibleMenuLinks().slice(0,20).map(hit);
    const blocked=links.filter(x=>!x.receivesClick);
    const counts={}; blocked.forEach(x=>counts[x.topElement]=(counts[x.topElement]||0)+1);
    const culprit=Object.entries(counts).sort((a,b)=>b[1]-a[1])[0];
    const diagnosis = !links.length ? 'No visible menu links found.' :
      !blocked.length ? 'All visible menu links pass hit-testing.' :
      `${blocked.length}/${links.length} menu links are blocked. Most common blocker: ${culprit?.[0] || 'unknown'}${culprit ? ` (${culprit[1]} links)` : ''}`;

    lastReport={
      time:new Date().toISOString(), url:location.href,
      viewport:{width:innerWidth,height:innerHeight},
      bodyClass:document.body.className,
      hero:hero ? styles(hero) : null,
      heroStackingAncestors:hero ? stackingAncestors(hero) : [],
      diagnosis, links
    };

    render(lastReport);
    console.group('[SEELENHAUCH MENU DEBUG]');
    console.log(diagnosis);
    console.log(lastReport);
    console.table(links.map(x=>({text:x.text,click:x.receivesClick,top:x.topElement,pointer:x.topStyle.pointerEvents,position:x.topStyle.position,zIndex:x.topStyle.zIndex})));
    console.groupEnd();
  }

  function render(r){
    const body=$('#shd-body'); if(!body) return;
    body.innerHTML=`
      <div class="shd-diagnosis ${r.links.some(x=>!x.receivesClick)?'bad':'ok'}">${esc(r.diagnosis)}</div>
      <div class="shd-row"><b>Body classes</b><code>${esc(r.bodyClass||'(none)')}</code></div>
      <div class="shd-row"><b>Hero</b><code>${esc(r.hero?.element||'not found')}</code></div>
      <div class="shd-row"><b>Hero pointer</b><code>${esc(r.hero?.pointerEvents||'—')}</code></div>
      <div class="shd-row"><b>Hero z-index</b><code>${esc(r.hero?.zIndex||'—')}</code></div>
      ${r.links.slice(0,12).map(x=>`<div class="shd-link ${x.receivesClick?'ok':'bad'}"><div><strong>${esc(x.text||'(link)')}</strong><span>${x.receivesClick?'CLICK OK':'BLOCKED'}</span></div><code>top: ${esc(x.topElement)}</code><code>pointer: ${esc(x.topStyle.pointerEvents)}</code><code>position: ${esc(x.topStyle.position)}</code><code>z-index: ${esc(x.topStyle.zIndex)}</code></div>`).join('')}
    `;
  }

  function toggleHeroPointer(){
    let st=$('#shd-pointer-test');
    if(st){ st.remove(); setStatus('Pointer test OFF'); }
    else{
      st=document.createElement('style'); st.id='shd-pointer-test';
      st.textContent='.maison-hero-v2__content{pointer-events:none!important;}';
      document.head.appendChild(st); setStatus('Pointer test ON');
    }
    setTimeout(analyze,80);
  }

  async function copyReport(){
    if(!lastReport) analyze();
    const t=JSON.stringify(lastReport,null,2);
    try{ await navigator.clipboard.writeText(t); setStatus('Report copied'); }
    catch(e){ console.log(t); setStatus('Copy failed; printed in Console'); }
  }

  function setStatus(t){ const el=$('#shd-status'); if(el) el.textContent=t; }

  function build(){
    const style=document.createElement('style');
    style.textContent=`
      #sh-menu-debug{position:fixed;z-index:2147483647;right:10px;bottom:10px;width:min(390px,calc(100vw - 20px));max-height:72vh;overflow:auto;padding:12px;background:rgba(15,15,15,.97);color:#fff;border:1px solid rgba(255,255,255,.18);box-shadow:0 18px 50px rgba(0,0,0,.35);font:12px/1.45 ui-monospace,SFMono-Regular,Menlo,Consolas,monospace}
      #sh-menu-debug *{box-sizing:border-box}.shd-head{display:flex;justify-content:space-between;gap:10px;margin-bottom:10px}.shd-head strong{font:700 12px system-ui,sans-serif}.shd-actions{display:flex;gap:6px;flex-wrap:wrap;margin-bottom:8px}.shd-actions button{border:1px solid rgba(255,255,255,.2);background:#222;color:#fff;padding:7px 9px;cursor:pointer}.shd-diagnosis{padding:9px;margin:8px 0;border-left:3px solid #888;background:#222}.shd-diagnosis.bad{border-color:#ff2d55}.shd-diagnosis.ok{border-color:#34c759}.shd-row{display:grid;grid-template-columns:110px 1fr;gap:8px;padding:5px 0;border-bottom:1px solid rgba(255,255,255,.08)}.shd-row code{word-break:break-word}.shd-link{margin-top:8px;padding:8px;border:1px solid rgba(255,255,255,.1);background:#1c1c1c}.shd-link.bad{border-left:3px solid #ff2d55}.shd-link.ok{border-left:3px solid #34c759}.shd-link>div{display:flex;justify-content:space-between;gap:8px;margin-bottom:5px}.shd-link span{font-size:10px;color:#aaa}.shd-link code{display:block;color:#ccc;word-break:break-word}#shd-close{border:0;background:transparent;color:#fff;font-size:18px;cursor:pointer}#shd-status{color:#d7b28f;font-size:10px}`;
    document.head.appendChild(style);
    const panel=document.createElement('div'); panel.id='sh-menu-debug';
    panel.innerHTML=`<div class="shd-head"><div><strong>SEELENHAUCH MENU DEBUG</strong><div id="shd-status">Open menu, then Analyze</div></div><button id="shd-close">×</button></div><div class="shd-actions"><button id="shd-analyze">Analyze menu</button><button id="shd-pointer">Toggle hero pointer test</button><button id="shd-copy">Copy report</button></div><div id="shd-body">Open the mobile menu while over the Hero, then press <b>Analyze menu</b>.</div>`;
    document.body.appendChild(panel);
    $('#shd-analyze').onclick=analyze; $('#shd-pointer').onclick=toggleHeroPointer; $('#shd-copy').onclick=copyReport; $('#shd-close').onclick=()=>panel.remove();
  }

  function watch(){
    const obs=new MutationObserver(m=>{ if(m.some(x=>x.type==='attributes')) setTimeout(analyze,100); });
    obs.observe(document.body,{attributes:true,attributeFilter:['class']});
    $$('header-drawer details').forEach(d=>obs.observe(d,{attributes:true,attributeFilter:['open']}));
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>{build();watch();},{once:true});
  else { build(); watch(); }
})();
